export const productColumns = [
  {
    field: 'sNo',
    headerName: 'S.No',
  },
  {
    field: 'productName',
    headerName: 'Product Name',
    flex: 1,
  },
  {
  field: "images",
  headerName: "Product Image",
  flex: 1,
  renderCell: (params) => {
    // Get the first image object if available
    const imageObj =
      Array.isArray(params.value) && params.value.length > 0
        ? params.value[0]
        : null;

    // Build full URL
    const imageUrl = imageObj?.image
      ? `${process.env.REACT_APP_API_URL}/assets/images/products/${imageObj.image}`
      : "/default-image.png";

    return (
      <img
        src={imageUrl}
        alt="Product"
        style={{
          width: 60,
          height: 60,
          objectFit: "cover",
          borderRadius: 8,
        }}
      />
    );
  },
},
  {
    field: 'underCategory',
    headerName: 'Category',
    flex: 1,
    renderCell: (params) => {
      return params.value.map((category) => category.category).join(', ');
    },
  },
  // {
  //   field: 'priceAndQuantity',
  //   headerName: 'Price & Quantity',
  //   flex: 1,
  //   renderCell: (params) => {
  //     return params.value
  //       .map(
  //         (priceQuant) =>
  //           `Price: ${priceQuant.price}, Quantity: ${priceQuant.quantity}`
  //       )
  //       .join('\n');
  //   },
  // },
  {
    field: 'stockAvailability',
    headerName: 'Stock Availability',
      flex: 1,
  renderCell: (params) => {
    return params.row.status === "Out Of Stock" 
      ? "Out of Stock" 
      : "In Stock";
  }
},
  // {
  //   field: 'totalCount',
  //   headerName: 'Total Count',
  //   flex: 1,
  //   renderCell: (params) =>
  //     params.row.priceAndQuantity && Array.isArray(params.row.priceAndQuantity)
  //       ? params.row.priceAndQuantity[0].totalCount
  //       : 'N/A',
  // },
  {
    field: 'isFeatured',
    headerName: 'Featured',
    flex: 1,
  },
  {
    field: 'isActive',
    headerName: 'Active',
    flex: 1,
  },
  // {
  //   field: 'description',
  //   headerName: 'Description',
  //   flex: 1,
  //   renderCell: (params) => params.value.shortDescription,
  // },
];
export const categoryColumns = [
  {
    field: 'sNo',
    headerName: 'S.No',
    flex: 1,
  },
  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
  },
  {
    field: 'noOfProducts',
    headerName: 'No.Of.Products',
    flex: 1,
  },
  {
    field: 'isActive',
    headerName: 'Active',
    flex: 1,
  },
];
export const newsEventsColumns = [
  {
    field: 'sNo',
    headerName: 'S.No',
  },
  {
    field: 'images',
    headerName: 'Image',
  },
  {
    field: 'title',
    headerName: 'Title',
  },
  {
    field: 'description',
    headerName: 'Description',
  },
  {
    field: 'date',
    headerName: 'Date',
  },
];
export const homeSlideColumns = [
  {
    field: 'sNo',
    headerName: 'S.NO',
    flex: 1,
  },
  // {
  //   field: 'images',
  //   headerName: 'Product Image',
  //   flex: 1,
  //   renderCell: (params) => {
  //     const imageObj =
  //       Array.isArray(params.value) && params.value.length > 0
  //         ? params.value[0]
  //         : null;

  //     const imageUrl =
  //       imageObj && imageObj.image ? imageObj.image : '/default-image.png';

  //     return (
  //       <img
  //         src={imageUrl}
  //         alt='Product'
  //         style={{ width: '100%', height: 'auto' }}
  //       />
  //     );
  //   },
  // },
  {
    field: 'title',
    headerName: 'TITLE',
    flex: 1,
  },
  {
    field: 'description',
    headerName: 'DESCRIPTIONS',
    flex: 1,
  },
  {
    field: 'isActive',
    headerName: 'ACTIVE',
    flex: 1,
  },
];
export const sellersColumns = [
  {
    field: 'sNo',
    headerName: 'S.No',
    // flex: 1,
    // minWidth: 20,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'displayName',
    headerName: 'Display Name',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'gender',
    headerName: 'Gender',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'emailId',
    headerName: 'Email Id',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'isActive',
    headerName: 'Active',
    flex: 1,
  },
];
export const buyersColumns = [
  {
    field: 'sNo',
    headerName: 'S.No',
    // flex: 1,
    // minWidth: 20,
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'displayName',
    headerName: 'Display Name',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'gender',
    headerName: 'Gender',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'emailId',
    headerName: 'Email Id',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'isActive',
    headerName: 'Active',
    flex: 1,
  },
];
export const partnersDetailsColumns = [
  {
    field: 'sNo',
    headerName: 'S.No',
    flex: 1,
  },
  {
    field: 'partnerName',
    headerName: 'Name',
    flex: 1,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1,
  },
  {
    field: 'isActive',
    headerName: 'Active',
    flex: 1,
  },
];
